RivalIQ.apps.LandscapeSettings.module('views', function (views, App, Backbone, Marionette, $, _, d3) {

    'use strict';

    views.Preview = Marionette.ItemView.extend({
        ui: {
            bar: '.x-bar',
            title: '.x-title',
            primary: '.x-primary',
            subtitle: '.x-subtitle',
            landscape: '.x-landscape',
            customLogo: '.x-custom-logo'
        },
        barChartWidth: 175,
        barChartTextWidth: 90,
        barChartFocusCompanyClassName: 'x-focus',
        className: 'row',
        colorChangeEventName: 'color-change',
        initialize: function (options) {
            const me = this;
            const opts = options || {};

            _.extend(me, _.pick(opts, 'landscape', 'focusCompany',
                'barChartWidth', 'barChartTextWidth', 'barChartFocusCompanyClassName'));
            _.bindAll(me, 'template');

            // we need to keep track of colors apart from the model so that updates
            // to them (the colors) are only persisted on save
            me.colors = _.map(me.model.get('colors'), function (color) {
                return color.color;
            });

            me.initializeEvents();
        },
        modelEvents: {
            'change:logo': 'render'
        },
        onRender: function () {
            const me = this;
            const ui = me.ui;
            const colors = me.colors;

            ui.title.css('color', colors[0]);
            ui.primary.css('color', colors[2]);
            ui.subtitle.css('color', colors[1]);

            me.renderBarGraph(colors);

            if (!me.model.get('logo')) {
                ui.customLogo.removeClass('hide');
            }
        },
        renderBarGraph: function (colors) {
            const me = this;

            const data = [
                {
                    name: 'Company A',
                    value: 5
                },
                {
                    name: 'Highlight Co',
                    value: 10
                },
                {
                    name: 'Company B',
                    value: 15
                }
            ];

            const width = me.barChartWidth;
            const barPadding = 10;
            const barHeight = 25;
            const barOffset = 5;

            const x = d3.scale.linear()
                .domain([0, d3.max(data, function (d) {
                    return d.value;
                })])
                .range([0, width]);

            const chart = d3.select(me.ui.bar[0])
                .attr('width', width)
                .attr('height', (barHeight + barPadding) * data.length);

            const bar = chart.selectAll('g')
                .data(data)
                .enter().append('g')
                .attr('transform', function (d, i) {
                    return `translate(0,${i * (barHeight + barPadding)})`;
                });

            const getColor = function (d, i) {
                return (i % 2 === 0) ? colors[2] : colors[3];
            };

            bar.append('text')
                .attr('x', 0)
                .attr('y', ((barHeight + barPadding) / 2) + barOffset)
                .attr('class', function (d, i) {
                    return (i % 2 !== 0) ? me.barChartFocusCompanyClassName : null;
                })
                .attr('text-anchor', 'beginning')
                .text(function (d) {
                    return d.name;
                });

            bar.append('rect')
                .attr('x', me.barChartTextWidth)
                .attr('y', barOffset)
                .attr('fill', getColor)
                .attr('stroke', getColor)
                .attr('width', function (d) {
                    return x(d.value) / 2;
                })
                .attr('height', barHeight - 1);

            chart.append('line')
                .attr('x1', me.barChartTextWidth)
                .attr('y1', 0)
                .attr('x2', me.barChartTextWidth)
                .attr('y2', (barHeight + barPadding) * data.length)
                .attr('stroke-width', 1)
                .attr('stroke', '#000');
        },
        template: function (data) {
            const me = this;
            let cachedTemplate = me.cachedTemplate;

            _.extend(data, _.pick(me, 'landscape', 'focusCompany'));

            if (!cachedTemplate) {
                cachedTemplate = me.cachedTemplate = _.template($('#settingsPreviewTemplate').html());
            }

            return cachedTemplate(data);
        },
        initializeEvents: function () {
            const me = this;
            me.listenTo(App.vent, me.colorChangeEventName, me.onColorChange);
        },
        onColorChange: function (color, index) {
            const me = this;

            me.colors[index] = color;

            me.render();
        }
    });
}, window.d3);
